<div class="p-5">
  <div class="flex items-center gap-2 mb-3">
    <mat-icon style="color: #1C593D;">receipt_long</mat-icon>
    <h2 style="font-size: 1.05rem; font-weight: 700; color: #111827; margin: 0;">Detalle de movimiento N58</h2>
  </div>

  <div *ngIf="movement" class="flex flex-col gap-3">
    <!-- Header: tipo + status + monto -->
    <div class="grid grid-cols-2 sm:grid-cols-3 gap-2">
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Tipo</div>
        <span class="px-2 py-0.5 text-xs font-bold rounded-full" [ngClass]="getTypeClass(movement.movementType)">
          {{ getTypeLabel(movement.movementType) }}
        </span>
      </div>
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Status</div>
        <div class="font-bold">{{ getStatusLabel(movement.status) }}</div>
      </div>
      <div class="bg-gray-50 rounded-lg p-2">
        <div class="text-xs text-gray-500 uppercase font-semibold">Monto</div>
        <div class="font-bold">
          {{ getAmountSign(movement.movementType) }}{{ movement.amount | number:'1.2-2' }}
          {{ movement.currency || 'Bs' }}
        </div>
      </div>
    </div>

    <!-- Conciliación (solo aplica a payins) -->
    <div *ngIf="movement.movementType === 'payin' && movement.conciliationStatus"
      class="bg-gray-50 rounded-lg p-2 flex items-center gap-2">
      <span class="text-xs text-gray-500 uppercase font-semibold">Conciliación:</span>
      <span class="px-2 py-0.5 text-xs font-bold rounded-full" [ngClass]="getConciliationClass(movement.conciliationStatus)">
        {{ getConciliationLabel(movement.conciliationStatus) }}
      </span>
      <span *ngIf="movement.matchedAt" class="text-xs text-gray-500">
        · {{ movement.matchedAt | date:'dd/MM/yyyy HH:mm':'America/Caracas' }}
      </span>
    </div>

    <!-- ===================================================================
         Cliente y beneficiario.
         Nada de esto viene en el listado: lo cruza `GET /n58/movements/:id`
         al leer. Cada tarjeta declara de dónde salió el dato, porque no
         todas valen lo mismo: lo que dice el banco es inmutable, lo nuestro
         es el estado actual de una ficha que el cliente puede editar.
         =================================================================== -->
    <div *ngIf="detalleLoading" class="flex items-center gap-2 text-xs text-gray-400">
      <mat-spinner diameter="16"></mat-spinner>
      <span>Buscando cliente y beneficiario…</span>
    </div>

    <div *ngIf="detalleError" class="bg-amber-50 border border-amber-200 rounded-lg p-2 text-xs text-amber-800">
      {{ detalleError }}. El movimiento de arriba es correcto igual.
    </div>

    <div *ngIf="hayContraparte" class="grid grid-cols-1 sm:grid-cols-2 gap-2">

      <!-- Cliente: el usuario de la wallet detrás del movimiento -->
      <div *ngIf="detalle?.cliente" class="rounded-lg p-2 border" style="background: #f5f3ff; border-color: #ddd6fe;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #6d28d9;">person</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #6d28d9;">Cliente</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ clienteNombre || '—' }}</div>
        <div class="text-xs text-gray-600 mt-0.5">
          ID: <code>{{ detalle?.cliente?.usuarioId }}</code>
          <span *ngIf="detalle?.cliente?.documento"> · {{ detalle?.cliente?.documento }}</span>
        </div>
        <div *ngIf="detalle?.cliente?.email" class="text-xs text-gray-600" style="word-break: break-all;">
          {{ detalle?.cliente?.email }}
        </div>
        <div *ngIf="detalle?.cliente?.paisResidencia" class="text-xs text-gray-400 mt-0.5">
          {{ detalle?.cliente?.paisResidencia }}
        </div>
      </div>

      <!-- Beneficiario segun nuestro registro (payouts) -->
      <div *ngIf="detalle?.beneficiario" class="rounded-lg p-2 border" style="background: #fef2f2; border-color: #fecaca;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #b91c1c;">call_made</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #b91c1c;">Beneficiario</span>
          <span class="text-xs text-gray-400">· nuestro registro</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ detalle?.beneficiario?.nombre || '—' }}</div>
        <div *ngIf="detalle?.beneficiario?.documento" class="text-xs text-gray-600 mt-0.5">
          {{ detalle?.beneficiario?.documento }}
        </div>
        <div *ngIf="detalle?.beneficiario?.cuenta" class="text-xs text-gray-600" style="font-family: monospace;">
          {{ detalle?.beneficiario?.cuenta }}
          <span *ngIf="detalle?.beneficiario?.esPagoMovil" class="text-gray-400">(pago móvil)</span>
        </div>
        <div *ngIf="detalle?.beneficiario?.bancoNombre" class="text-xs text-gray-500 mt-0.5">
          {{ detalle?.beneficiario?.bancoNombre }}
          <span *ngIf="detalle?.beneficiario?.bancoCodigo">({{ detalle?.beneficiario?.bancoCodigo }})</span>
        </div>
        <!-- La ficha del beneficiario es editable: puede no ser la misma que
             se usó el día del pago. La versión inmutable es la del banco. -->
        <div class="text-xs text-gray-400 mt-1">Ficha actual del cliente</div>
      </div>

      <!-- Contraparte segun el propio movimiento: en un payin, quien pago -->
      <div *ngIf="detalle?.contraparte?.nombre || detalle?.contraparte?.cuenta"
        class="rounded-lg p-2 border" style="background: #f0fdf4; border-color: #bbf7d0;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #15803d;">account_balance</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #15803d;">
            {{ movement.movementType === 'payin' ? 'Pagador' : 'Contraparte' }}
          </span>
          <span class="text-xs text-gray-400">· lo dice el banco</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ detalle?.contraparte?.nombre || '—' }}</div>
        <div *ngIf="detalle?.contraparte?.cuenta" class="text-xs text-gray-600" style="font-family: monospace;">
          {{ detalle?.contraparte?.cuenta }}
        </div>
        <div *ngIf="detalle?.contraparte?.bancoCodigo" class="text-xs text-gray-500 mt-0.5">
          Banco {{ detalle?.contraparte?.bancoCodigo }}
        </div>
        <!-- El feed de movimientos no manda documento de la contraparte: no
             es que falte el campo, es que N58 no lo envía. -->
        <div *ngIf="movement.movementType === 'payin'" class="text-xs text-gray-400 mt-1">
          N58 no envía el documento del pagador
        </div>
      </div>

      <!-- Referencia VES del payin: lo que declaró el cliente -->
      <div *ngIf="detalle?.referenciaVes" class="rounded-lg p-2 border" style="background: #eff6ff; border-color: #bfdbfe;">
        <div class="flex items-center gap-1.5 mb-1">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1d4ed8;">assignment_turned_in</mat-icon>
          <span class="text-xs font-bold uppercase" style="color: #1d4ed8;">Referencia declarada</span>
        </div>
        <div class="text-sm font-semibold text-gray-900">{{ detalle?.referenciaVes?.titular || '—' }}</div>
        <div class="text-xs text-gray-600 mt-0.5">
          {{ detalle?.referenciaVes?.banco }}
          <span *ngIf="detalle?.referenciaVes?.cuenta" style="font-family: monospace;">
            · {{ detalle?.referenciaVes?.cuenta }}
          </span>
        </div>
        <div class="text-xs text-gray-600">
          {{ detalle?.referenciaVes?.tipoCuenta }} · {{ detalle?.referenciaVes?.status }}
        </div>
        <div *ngIf="detalle?.referenciaVes?.operatorEmail" class="text-xs text-gray-400 mt-0.5">
          {{ detalle?.referenciaVes?.operatorEmail }}
        </div>
      </div>

    </div>

    <!-- La versión del banco, de su aviso de pago. Es la que hay que creerle
         cuando discrepa de la nuestra: la escribió el banco y no se edita. -->
    <details *ngIf="detalle?.bancoDice" class="bg-gray-50 rounded-lg p-2">
      <summary class="cursor-pointer font-semibold text-xs text-gray-700">
        Según el banco (aviso de pago)
        <span *ngIf="detalle?.bancoDice?.estado" class="text-gray-400">
          · {{ detalle?.bancoDice?.estado }}
        </span>
      </summary>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm mt-2">
        <div>
          <span class="text-gray-500 font-semibold text-xs uppercase">Ordenante:</span>
          {{ detalle?.bancoDice?.ordenanteNombre || '—' }}
          <div *ngIf="detalle?.bancoDice?.ordenanteDocumento" class="text-xs text-gray-600">
            {{ detalle?.bancoDice?.ordenanteDocumento }}
          </div>
          <div *ngIf="detalle?.bancoDice?.ordenanteCuenta" class="text-xs text-gray-600" style="font-family: monospace;">
            {{ detalle?.bancoDice?.ordenanteCuenta }}
            <span *ngIf="detalle?.bancoDice?.ordenanteBanco">· {{ detalle?.bancoDice?.ordenanteBanco }}</span>
          </div>
        </div>
        <div>
          <span class="text-gray-500 font-semibold text-xs uppercase">Beneficiario:</span>
          {{ detalle?.bancoDice?.beneficiarioNombre || '—' }}
          <div *ngIf="detalle?.bancoDice?.beneficiarioDocumento" class="text-xs text-gray-600">
            {{ detalle?.bancoDice?.beneficiarioDocumento }}
          </div>
          <div *ngIf="detalle?.bancoDice?.beneficiarioCuenta" class="text-xs text-gray-600" style="font-family: monospace;">
            {{ detalle?.bancoDice?.beneficiarioCuenta }}
            <span *ngIf="detalle?.bancoDice?.beneficiarioBanco">· {{ detalle?.bancoDice?.beneficiarioBanco }}</span>
          </div>
        </div>
        <div *ngIf="detalle?.bancoDice?.concepto" class="sm:col-span-2">
          <span class="text-gray-500 font-semibold text-xs uppercase">Concepto:</span>
          {{ detalle?.bancoDice?.concepto }}
        </div>
        <div *ngIf="detalle?.bancoDice?.motivo" class="sm:col-span-2 text-xs text-amber-800">
          {{ detalle?.bancoDice?.motivo }}
        </div>
        <div *ngIf="detalle?.bancoDice?.recibidoEl" class="sm:col-span-2 text-xs text-gray-400">
          Aviso recibido: {{ detalle?.bancoDice?.recibidoEl | date:'dd/MM/yyyy HH:mm:ss':'America/Caracas' }}
        </div>
      </div>
    </details>

    <!-- Nuestro lado del payout: transacción interna y log de ejecución -->
    <div *ngIf="detalle?.transaccion || detalle?.payoutLog"
      class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm bg-gray-50 rounded-lg p-2">
      <div *ngIf="detalle?.transaccion">
        <span class="text-gray-500 font-semibold text-xs uppercase">Transacción:</span>
        <code class="text-xs">{{ detalle?.transaccion?.id }}</code>
        <span class="text-xs text-gray-500"> · {{ detalle?.transaccion?.estado }}</span>
        <div *ngIf="detalle?.transaccion?.montoOrigen" class="text-xs text-gray-600">
          {{ detalle?.transaccion?.montoOrigen | number:'1.2-2' }} {{ detalle?.transaccion?.monedaOrigen }}
          → {{ detalle?.transaccion?.montoDestino | number:'1.2-2' }} {{ detalle?.transaccion?.monedaDestino }}
        </div>
      </div>
      <div *ngIf="detalle?.payoutLog">
        <span class="text-gray-500 font-semibold text-xs uppercase">Ejecución:</span>
        {{ detalle?.payoutLog?.status }}
        <div *ngIf="detalle?.payoutLog?.operadorEmail" class="text-xs text-gray-600">
          {{ detalle?.payoutLog?.operadorEmail }}
        </div>
        <div *ngIf="detalle?.payoutLog?.comision" class="text-xs text-gray-600">
          Comisión: {{ detalle?.payoutLog?.comision }} · saldo después: {{ detalle?.payoutLog?.saldoDespues }}
        </div>
        <div *ngIf="detalle?.payoutLog?.errorDetail" class="text-xs text-red-700">
          {{ detalle?.payoutLog?.errorCode }} — {{ detalle?.payoutLog?.errorDetail }}
        </div>
      </div>
    </div>

    <!-- Datos principales -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
      <div *ngIf="movement.transactionName">
        <span class="text-gray-500 font-semibold text-xs uppercase">Descripción:</span>
        {{ movement.transactionName }}
      </div>
      <div *ngIf="movement.referenceNumber">
        <span class="text-gray-500 font-semibold text-xs uppercase">Referencia:</span>
        <code class="text-xs">{{ movement.referenceNumber }}</code>
      </div>
      <div *ngIf="movement.transactionCode">
        <span class="text-gray-500 font-semibold text-xs uppercase">Código:</span>
        <code class="text-xs">{{ movement.transactionCode }}</code>
      </div>
      <div *ngIf="movement.accountNumber">
        <span class="text-gray-500 font-semibold text-xs uppercase">Cuenta:</span>
        <code class="text-xs">{{ movement.accountNumber }}</code>
      </div>
      <div *ngIf="movement.n58Type">
        <span class="text-gray-500 font-semibold text-xs uppercase">Naturaleza:</span>
        {{ movement.n58Type }}
        <span class="text-xs text-gray-400">
          ({{ movement.n58Type === 'C' ? 'crédito' : 'débito' }})
        </span>
      </div>
      <div *ngIf="movement.userId">
        <span class="text-gray-500 font-semibold text-xs uppercase">User ID:</span>
        <code class="text-xs">{{ movement.userId }}</code>
      </div>
      <div *ngIf="movement.referenciaVesId">
        <span class="text-gray-500 font-semibold text-xs uppercase">Ref VES:</span>
        <code class="text-xs">{{ movement.referenciaVesId }}</code>
      </div>
      <div *ngIf="movement.referenciaTitular">
        <span class="text-gray-500 font-semibold text-xs uppercase">Titular:</span>
        {{ movement.referenciaTitular }}
      </div>
      <div *ngIf="movement.referenciaTipoCuenta">
        <span class="text-gray-500 font-semibold text-xs uppercase">Tipo cuenta:</span>
        {{ movement.referenciaTipoCuenta }}
      </div>
      <div *ngIf="movement.referenciaOperatorEmail">
        <span class="text-gray-500 font-semibold text-xs uppercase">Operador:</span>
        {{ movement.referenciaOperatorEmail }}
      </div>
      <div>
        <span class="text-gray-500 font-semibold text-xs uppercase">Fecha tx:</span>
        {{ movement.transactionDate | date:'dd/MM/yyyy HH:mm:ss':'America/Caracas' }}
      </div>
      <div *ngIf="movement.createdAt">
        <span class="text-gray-500 font-semibold text-xs uppercase">Registrado:</span>
        {{ movement.createdAt | date:'dd/MM/yyyy HH:mm:ss':'America/Caracas' }}
      </div>
    </div>

    <!-- Concepto -->
    <div *ngIf="movement.transactionConcept" class="bg-yellow-50 border border-yellow-200 rounded-lg p-2 text-sm">
      <strong class="text-yellow-800">Concepto:</strong> {{ movement.transactionConcept }}
    </div>

    <!-- Indicador interno (acreditado interno N58) -->
    <div *ngIf="movement.isInternalCredit" class="bg-blue-50 border border-blue-200 rounded-lg p-2 text-sm flex items-center gap-2">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1d4ed8;">admin_panel_settings</mat-icon>
      <span class="text-blue-800 font-semibold">Acreditado interno N58 (referencia creada por operador)</span>
    </div>

    <!-- Raw detail collapsible -->
    <details *ngIf="movement.rawDetail" class="bg-gray-50 rounded-lg p-2">
      <summary class="cursor-pointer font-semibold text-xs text-gray-700">Raw detail (banco N58)</summary>
      <pre class="text-xs overflow-auto mt-2" style="max-height: 240px;">{{ movement.rawDetail | json }}</pre>
    </details>

    <!-- IDs internos -->
    <div class="text-xs text-gray-400 mt-2">
      <div>UUID tx: <code>{{ movement.transactionUuid }}</code></div>
      <div *ngIf="movement.dedupKey">Dedup key: <code>{{ movement.dedupKey }}</code></div>
    </div>
  </div>

  <div class="flex justify-end mt-4">
    <button type="button" (click)="close()"
      style="padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      Cerrar
    </button>
  </div>
</div>
